module.exports = __webpack_public_path__ + "static/img/invite-share.6a0c572f.png";